import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import {
  IOrderSalesApprovalRequestService,
  CHANNEL_SALES_APPROVAL_SERVICE,
} from "../IOrderSalesApprovalRequestService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";
import { BasePrimaryActionService } from "./BasePrimaryActionService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class OrderSalesApprovalRequestPromiseService
  extends BasePrimaryActionService
  implements IOrderSalesApprovalRequestService
{
  abstract requestApproval(
    ids: Array<string>,
    comment: string,
    action: CubiqTS.SalesApprovalAction,
  ): Promise<any>;
  abstract getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable>;
}
